<template>
    <div>
        <form v-on:submit.prevent="onSubmit">
            <div class="d-block pt-5">
                <div class="row justify-content-center">
                    <div class="col-md-8">
                        <div class="d-block h2 font-bold mb-5"><i class="fa-solid fa-caret-right me-3 text-neon"></i>Masukan Data Prestasi Siswa</div>                    
                        <div class="d-block">
                            <div class="card" v-if="total_achievement < 1">
                                <div class="card-body">
                                    <div class="d-block text-center py-4">
                                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                                        <div class="d-block text-sm text-muted ">Data Prestasi tidak ditemukan</div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="total_achievement > 0">
                                <div v-for="(row, indexRow) in total_achievement" :key="indexRow" class="card bg-card-trans" >
                                    <div class="card-header">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <div class="d-block font-bold text-pink">Prestasi {{ row }}</div>
                                            <div class="d-block">
                                                <button type="button" class="btn btn-white-naked btn-sm" v-on:click="removeRow"><i class="fa-solid fa-trash-can me-3 text-danger"></i>Hapus Prestasi</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body pb-0">
                                        <div class="row">
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="form-label">Tingkat<i
                                                            class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                                    <div class="form-select-wrapper form-select-style-1">
                                                        <i class="fa-solid fa-caret-down"></i>
                                                        <select class="form-select form-select-box-1" v-model="form.grade_id[indexRow]" v-on:change="getEvents(indexRow)">
                                                            <option value="">Pilih Tingkat</option>
                                                            <option value="international">Internasional</option>
                                                            <option value="national">Nasional</option>
                                                            <option value="province">Provinsi</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <label class="form-label">Event<i
                                                            class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                                    <div class="form-select-wrapper form-select-style-1">
                                                        <i class="fa-solid fa-caret-down"></i>
                                                        <select class="form-select form-select-box-1" v-model="form.achievement_id[indexRow]">
                                                            <option value="">Pilih Event</option>
                                                            <option v-for="(item, index) in form.data_events[indexRow]" :key="index" :value="item.id">{{ item.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label class="form-label">Unggah Berkas<i
                                                            class="fa-solid fa-circle-exclamation fa-sm ms-2 text-pink"></i></label>
                                                    <input type="file" class="form-control" @change="onFileChange(indexRow, $event)">
                                                    <div v-if="form.before_attachment[indexRow]" class="d-block text-sm text-end mt-3"><small><a :href="form.before_attachment[indexRow]" class="text-white" target="_blank">File sebelumnya : (Lihat File)</a> </small></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-block mb-4">
                                <button v-on:click="addRow" type="button" class="btn btn-white-naked"><i class="fa-solid fa-add me-3"></i>Tambah Prestasi</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end mt-4 pt-4 border-top mb-5">
                <button type="submit" class="btn btn-primary btn-lg btn-s-1" :disabled="waiting">
                    <div class="btn-s-1-inner">{{ waiting ? 'Menyimpan...' : 'Selanjutnya' }}<i class="fa-solid fa-arrow-right fa-lg ms-3"></i></div>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'RationalizationFormAchievement',
    data() {
        return {
            dataEvents : [],
            dataAchievement : [],
            form : {
                id              : [],
                grade_id        : [],
                achievement_id  : [],
                attachment      : [],
                before_attachment      : [],
                data_events     : []
            },
            submitted           : false,
            waiting             : false,
            total_achievement : 0
        }
    },
    created() {
        this.getAchievement();
    },
    methods: {
        initializeRow: function() {
            const currentLength               = this.total_achievement-1;

            for (let key in this.form) {
                this.form[key][currentLength] = "";
            }
        },
        getAchievement: function() {
            this.dataAchievement = [];
            let uri         = process.env.VUE_APP_APIHOST+'rationalization/detail-achievement';
            this.$http.get(uri,{
                params : {
                    code    : this.$parent.dataRationalization.code
                }
            }).then(res => {
                if(res.data.status) {
                    this.dataAchievement    = res.data.data;
                    this.total_achievement  = this.dataAchievement.length;

                    this.dataAchievement.forEach( (element, index) => {
                        this.form.id[index]                 = element.id;
                        this.form.grade_id[index]           = element.grade;
                        this.getEvents(index);
                        this.form.achievement_id[index]     = element.achievement_id;
                        this.form.attachment[index]         = element.attachment;
                        this.form.before_attachment[index]  = element.attachment;
                    });

                }
             });
        },
        getEvents: function(index) {
            this.form.achievement_id[index] = "";
            let uri         = process.env.VUE_APP_APIHOST+'achievement/list-by-grade';
            this.$http.get(uri,{
                params : {
                    grade    : this.form.grade_id[index]
                }
            }).then(res => {
                this.$set(this.form.data_events, index, res.data.data);
            });
        },
        addRow: function() {
            this.total_achievement = this.total_achievement+1;
            this.initializeRow();
        },
        removeRow: function() {
            this.total_achievement = this.total_achievement-1;            
        },
        onSubmit: function () {
            this.waiting    = true;
            this.submitted  = true;

            let formData = new FormData();

            formData.append('rationalization_id', this.$parent.dataRationalization.id);
            formData.append('code', this.$parent.dataRationalization.code);
            formData.append('total_achievement', this.total_achievement);
            formData.append('tab_active', this.$parent.tabActive);
            for (let key in this.form) {
                if (key === 'attachment') {
                    for (let i = 0; i < this.form[key].length; i++) {
                        formData.append(`${key}[${i}]`, this.form[key][i]);
                    }
                } else {                    
                    formData.append(key, JSON.stringify(this.form[key]));
                }
            }

            this.$http.post(process.env.VUE_APP_APIHOST + 'rationalization/save-achievement', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                // Pindah ke halaman edit hanya kalau belum di sana.
                                // form.id berupa array, jadi `form.id == ''` tidak bisa dipakai
                                // untuk cek data baru ([] dan [""] sama-sama == '').
                                if(this.$route.params.code !== response.data.code) {
                                    this.$router.push({
                                        name : 'rationalization_form_edit',
                                        params: { code: response.data.code }
                                    });
                                }

                                this.getAchievement();
                                this.$parent.getStep();
                            }
                        });
                    } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: response.data.message,
                        });
                    }
                    this.waiting = false;
                })
            .catch(function () {
                this.$swal({
                    icon: 'warning',
                    title: 'Ups!',
                    text: 'Please check your internet connection.',
                });
                this.waiting = false;
                return;
            });
        },
        onFileChange(index, event) {
            const file = event.target.files[0];
            this.form.attachment[index] = file;
        },
    }
}
</script>